<template>
  <div class="tab-menu">
    <div v-for="(tab,i) in tabs" :key="i" class="tab-menu-item">
      <ContextMenu v-if="tab.items" :id="`tab-menu-item-${i}`" :items="tab.items">
        <div class="tab-menu-trigger" :class="{'current': tab.label == current}">
          <span class="text">{{ tab.label }}</span>
          <span class="icon icon-arrow-down"></span>
        </div>
      </ContextMenu>
      <a
        v-else
        class="tab-menu-trigger"
        :class="{'current': tab.label == current}"
        href="#"
        @click.prevent="itemClicked(tab)"
      >
        <span class="text">{{ tab.label }}</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tabs: { type: Array, required: true },
    current: { type: String, default: "" }
  },
  methods: {
    itemClicked(item) {
      if (_.has(item, "url")) {
        this.goToUrl(item.url);
      } else if (_.has(item, "action")) {
        item.action();
      }
    }
  }
};
</script>